import axios from 'axios';

const clienteAxios= axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL_AUTH,
    auth: {
        username: process.env.REACT_APP_BACKEND_CLIENT_ID,
        password: process.env.REACT_APP_BACKEND_CLIENT_SECRET
    }
});

export default clienteAxios;